import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';



class OtherFormsReact extends Component {
    constructor() {
        super();
        this.dialogClose = () => {
            this.setState({ hideDeletePopup: false, });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteOtherFormDataApi(this.state.propsId)
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];


        this.state = {
            language: null,
            data: [
                {
                    id: '',
                    question: '',
                    originalQuestionId: '',
                    autoTranslate: '',
                    alias: '',
                }
            ],
            pageNum : null,
            faqid: '',
            disabled: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit2.png',
            hidden: false,
            hideAddDialog: false,
            hideupdateDialog: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
    }

    NotifyFailToLoad() {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>Oops! Error occurred.Please try again</b>, {
            position: "top-center",
            color: "red"
        });
    }

    addRow = (data) => {
        var queController = this;
        if(queController.state.pageNum != 0) {
            queController.setState({pageNum : 0})
        }
        this.state.data.unshift({
            id: '',
            otherForm: '',
            autoTranslate: '',
        });
        this.setState({
            data: this.state.data,
            disabled: true
        })
    }

    addNewCellData = (props, e) => {
        this.state.data[props.index].question = document.getElementById("question" + props.index).innerText.trim();
        this.state.editedId = "-1";
        this.setState(this.state);
        var validateResult = this.validateCells(props.original.question);

        if (validateResult == true) {
            var addedData = {
                question: this.state.data[props.index].question,
                originalQuestionId: this.props.location.state.faqid,
            };

            var addOtherFormController = this
            $.ajax({
                url: "/api/faq-question-alias",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
                },
                data: addedData,
                success: function (res) {
                    if (res.success === true) {
                        addOtherFormController.NotifyAdd();
                        addOtherFormController.state.disabled = false;
                        addOtherFormController.fetchDataApi();
                    } else {
                        if (res.result != "") {
                            addOtherFormController.NotifyFailToAdd(res.result);
                            addOtherFormController.state.disabled = false;
                        }
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            })

        }
    }

    NotifyAdd() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Variation Added Successfully</b>, {
            position: "top-center",

        });

    }
    NotifyFailToAdd(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });

    }

    makeCelleditable(props, e) {
        this.markAsBeingEdited(this.state.data[props.index].id);
    }
    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    updateFaqApi(props, e) {
        this.state.data[props.index].question = document.getElementById("question" + props.index).innerText.trim();

        var validateResult = this.validateCells(props.original.question);
        if (validateResult == true) {
            var updatedData = {
                question: this.state.data[props.index].question,
                questionId: this.state.data[props.index].id,
                originalQuestionId: this.props.location.state.faqid,
            };
            var updatedDataController = this
            $.ajax({
                url: "/api/faq-question-alias-update",
                async: false,
                method: 'POST',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'contentType': 'application/x-www-form-urlencoded; charset=utf-8',
                },
                data: updatedData,
                success: function (res) {
                    if (res.success === true) {
                        updatedDataController.state.editedId = "-1";
                        updatedDataController.notifyUpdate();
                        updatedDataController.fetchDataApi();
                    } else {
                        if (res.result != "") {
                            updatedDataController.notifyFailToUpdate(res.result);
                        }
                        else {
                            updatedDataController.NotifyFailToLoad();
                        }
                    }
                },
                error: function (xhr, status, error) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            })
        }
    }

    notifyUpdate() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Variation Updated Successfully</b>, {
            position: "top-center",

        });
    }
    notifyFailToUpdate(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    validateCells(question) {
        if ((question == "")) {
            this.notifyEmptyField();
            return false;
        }
        else {
            return true;
        }
    }

    notifyEmptyField() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }

    deleteOtherFormDataApi = (id) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            deleteRowViewController.splice(id, 1);
        }
        $.ajax({
            url: "/api/faq-question-alias/" + id,
            async: false,
            method: 'DELETE',
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {

                if (res.success === true) {

                    deleteApiViewController.setState({ deleteRow: true });
                    deleteConstructorVariables.setState({ hideDeletePopup: false });
                    deleteRowViewController.splice(id, 1);
                    deleteApiViewController.notifyDeleted();
                    deleteApiViewController.fetchDataApi();


                } else {
                    if (res.result) {
                        deleteApiViewController.notifyFailedToDelete(res.result)
                    }
                    deleteApiViewController.NotifyFailToLoad();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }
    notifyDeleted() {
        toast.dismiss();
        toast(<b>
            <img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;Variation Deleted Successfully</b>, {
            position: "top-center"
        });
    }
    notifyFailedToDelete(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    refreshData = (id) => {
        var refreshContent = this
        refreshContent = this.state.editedId = id;
        this.fetchDataApi()
        this.setState({ disabled: false })
    }

    goBack = () => {
        this.props.history.push({
            pathname: "/projectmgmt/manage-knowledge/faq",
            state: { goBackToFaq: true, pageNum: this.props.location.state.pageNum }
        });
    }

    componentDidMount() {

        var faqid = this.props.location.state.faqid
        this.state.faqid = faqid;
        this.setState(this.state)
        setTimeout(() => {
            this.fetchDataApi();
        }, 300);
        
        document.addEventListener("projectChanged", function (event) {
            window.location.href = "/platform/projectmgmt/manage-knowledge/faq";
        });
    }


    fetchDataApi = () => {
        var otherFormController = this;
        $.ajax({
            url: "/api/faq-question-alias",
            async: false,
            method: 'GET',
            data: {
                "questionId": this.props.location.state.faqid,
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    var messages = res.result;
                    otherFormController.setState({
                        data: messages,
                        disabled: false,
                    })
                }
                else {
                    if (res.result != "") {
                        otherFormController.notifyFailedToLoadData(res.result)
                    }
                    otherFormController.NotifyFailToLoad();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }
    notifyFailedToLoadData(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    onPageChange = (e) => {
        this.setState({pageNum : e})
    }

    render() {
        const { data } = this.state
        const columns = [
            {
                Header: 'Qno',
                accessor: 'id',
                show: false,
                Cell: props => (
                    <div name="id" id={"id" + props.index}>{props.original.id}
                    </div>)
            },
            {
                Header: <b>Variation</b>,
                accessor: 'question',
                sortable: false,
                Cell: props =>(
                    <div name="message" className="textarea"
                      type="text"
                        style={{ background: 'white', resize: 'none', borderBottom: 'none', border: (props.original.id == this.state.editedId || props.original.id == "") ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == this.state.editedId || props.original.id == "") ? '2px' : 'none', paddingLeft: '2px' }}
                        id={"question" + props.index}

                        rows="1"
                        contentEditable={!((props.original.id == "") ? false :
                            props.original.id != this.state.editedId) ? "plaintext-only" : false}
                        suppressContentEditableWarning>{props.original.question}
                      
                    </div>)              
            },
            {
                Header: <b>Action</b>,
                accessor: 'action',
                width: 100,
                sortable: false,
                Cell: props => (
                    <div id="action">

                        <button
                            style={{
                                backgroundColor: "#ffffff", border: "none",
                                marginTop: '-13px'
                            }}>
                            <img className="img-responsive"
                                style={{ marginTop: '8px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                title={(props.original.id == "") ||
                                    (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}
                                src={(props.original.id == "") ?
                                    this.saveImageSrc : ((props.original.id != this.state.editedId) ?
                                        this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    (props.original.id == "") ?
                                        this.addNewCellData(props, e) :
                                        (props.original.id == this.state.editedId) ?
                                            this.updateFaqApi(props, e) :
                                            this.makeCelleditable(props, e);
                                }}
                            />
                        </button>
                        <button
                            style={{
                                backgroundColor: "#ffffff",
                                border: "none",
                                marginTop: '-9px', marginLeft: '-6px'
                            }} title="Delete"
                        >
                            <img className="img-responsive"
                                style={{
                                    marginTop: '6px',

                                    backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                                }}

                                src={"./assets/images/baseline_delete_white_24dp.png"}
                                onClick={() => (props.original.id) === '' ?
                                    this.fetchDataApi() :
                                    this.setState({
                                        hideDeletePopup: true, deletePropIndex: props.index,
                                        propsId: props.original.id
                                    })}
                            />
                        </button>

                    </div>
                ),

            },

        ]
        return (
            <div style={{ background: "#F9F9FB" }}>
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                {/* for reactTable */}
                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />


                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                {/* Font Awesome Icons */}
                <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                {/* IonIcons */}
                <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                {/* Select2 */}
                <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row">

                        </div>
                        <div className="row">
                            <div className="col-sm-4" style={{ marginTop: '16px' }} >
                                <img src="assets/images/arrow.svg" title="Go Back"
                                    onClick={this.goBack}
                                    style={{ paddingRight: "30%", cursor: 'pointer' }} />
                            </div>
                            <div className="col-sm-4">
                                <h6 className="nav-item" style={{ color: '#282a65', textAlign: 'center', marginTop: '16px' }}>
                                    Variations</h6>
                            </div>
                            {/* Add button */}
                            <div className="col-sm-4" Align='right'>
                                <button className="btn action-button "
                                    title="Add"
                                    id="addMsg"
                                    onClick={this.state.disabled ? this.notifyEmptyField : this.addRow}>
                                    <img src="assets/images/add_white_24dp.png" />
                                </button>
                                <button onClick={this.refreshData} className="btn action-button"
                                    title="Refresh">
                                    <img src="./assets/images/refresh_white_24dp.png"></img>
                                </button>
                            </div>
                        </div>
                    </div>
                    {/* left Menu start here*/}
                    {/* Content Header (Page header) */}
                    {/* /.content-header */}
                    {/* Custom Tabs */}
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-lg-12 ">
                                    <div className="card">
                                        <ReactTable
                                            data={data}
                                            columns={columns}
                                            defaultPageSize={10}
                                            pageSizeOptions={[5, 10, 15]}
                                            onPageChange={this.onPageChange}
                                            page={this.state.pageNum}
                                        />
                                    </div>
                                    <ToastContainer className="Toast-at-center"/>

                                    {/*Dialog Component For Deletion Confirmation*/}
                                    <DialogComponent width='400px' animationSettings={this.settings}
                                        header='Variation' showCloseIcon={true} buttons={this.buttons}
                                        ref={dialog => this.dialogInstance = dialog}
                                        visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                        <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                            content="" />&nbsp;Do you want to delete the Variation?&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default OtherFormsReact


// WEBPACK FOOTER //
// ./src/projectmgmt/faq/OtherFormsReact.js